import { createActions } from "redux-actions";

const actions = createActions(
  {
    SET: (ride) => ({ ride }),
    SET_NEW_RIDE_ID: (rideId) => ({ rideId }),
  },
  { prefix: "RIDES" },
);

export const {
  set,
  setNewRideId,
} = actions;
